import script from "./MobileSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileSetting.vue?vue&type=script&setup=true&lang=js"

import "./MobileSetting.vue?vue&type=style&index=0&id=0b242ea3&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b242ea3"]])

export default __exports__